/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Read_MoreInputs */



/**
* | output |
* | --- |
* | "Read more" |
*
* @param {Practice_Read_MoreInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_read_more = /** @type {((inputs?: Practice_Read_MoreInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Read_MoreInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Lees meer")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lire la suite")
	return /** @type {LocalizedString} */ ("Read more")
});